module.exports = __webpack_public_path__ + "img/word_default.75839ded.png";